module.exports = __webpack_public_path__ + "img/inaccess.e60b2679.svg";